"use strict";

import axios from "@/plugins/axios";
import he from 'he';
// import helpers from "@/plugins/helpers";

export const department = {
  namespaced: true,
  state: {
    data: [],
    current_department: {}
  },
  getters: {
    getDepartments: state => state.data,
    getCurrentDepartment: state => state.current_department
  },
  mutations: {
    UPDATE_DATA: (state, payload) => (state.data = payload),
    SET_CURRENT_DEPARTMENT: (state, payload) => (state.current_department = payload),
  },
  actions: {
    async getDepartments({ commit }) {
      try {
        let res = (await axios.get("/api/departments")).data;

        res.data.forEach((dep,index) => {
          res.data[index].description = he.decode(dep.description);
        });

        commit("UPDATE_DATA", res.data);
      } catch (error) {
        return error

      }
    },

    async getDepartment({ commit }, payload) {
      try {
        let res = (await axios.get(`/public/department/${payload}`)).data

        if (res.success) {
          res.data.description = he.decode(res.data.description);
          commit('SET_CURRENT_DEPARTMENT', res.data);}
        return true;
      } catch (error) {
        return error;
      }
    },
    async makePublic({ state }, payload) {
      try {
        let res = (await axios.post('/api/departments/triggerPublic', payload)).data

        if (res.success) state.data = state.data.map(dep => dep._id === res.data._id ? res.data : dep);
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
      } catch (e) {
        return e

      }
    },
    async updateDepartment({ state }, payload) {
      try {
        let res = (await axios.post('/api/departments', payload)).data
        if (res.success) {
          res.data.description = he.decode(res.data.description)
          state.data = state.data.map(dep => dep._id === res.data._id ? res.data : dep);}
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
      } catch (e) {

        return e
      }
    },
    async uploadImage({ state }, payload) {
      try {


        let res = (
          await axios.post(`api/department/uploadImage/${payload._id}`, payload.formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
        ).data;

        if (res.success) state.data = state.data.map(dep => dep._id === res.data._id ? res.data : dep)
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
      } catch (error) {
        window.flash({
          type: "error",
          msg: error.message,
        });
      }
    },


    async deleteDepartment({state, dispatch}, payload) {
      try {
        let res = (await axios.delete(`api/department/${payload.id}`)).data
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
        if(res.success) {
          dispatch('user/getUsers', {}, {root:true})
        }
        state.data = state.data.filter(dep => dep._id !== payload.id)
      } catch (e) {
        window.flash({ type: "error", msg: "Da ist etwas schief gelaufen. Das Problem wurde gemeldet um sich darum zu kümmern." })
      }
    },

    async uploadIcon({ state }, payload) {
      try {
        let res = (
          await axios.post(`api/department/uploadIcon/${payload._id}`, payload.formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
        ).data;

        if (res.success) state.data = state.data.map(dep => dep._id === res.data._id ? res.data : dep)
        window.flash({
          type: res.success ? "success" : "error",
          msg: res.message,
        });
      } catch (error) {
        window.flash({
          type: "error",
          msg: error.message,
        });
      }

    },
  }
};

